import React from "react";
import "./Contact.css";

/**
 * Contact.jsx
 * - Black theme, Orbitron title/button
 * - Posts to FormSubmit so you can receive messages at admin@junebase.com
 */
export default function Contact() {
  const actionUrl = "https://formsubmit.co/admin@junebase.com";

  return (
    <section className="jb-contact">
      <div className="jb-container">
        <h2 className="jb-title">Contact Junebase Robotics</h2>
        <p className="jb-sub">
          Want to collaborate or test Version 1? Use the contact form below.
        </p>

        <form className="jb-form" action={actionUrl} method="POST">
          {/* FormSubmit options */}
          <input type="hidden" name="_captcha" value="false" />
          <input
            type="hidden"
            name="_next"
            value={typeof window !== "undefined" ? window.location.href : "/"}
          />
          {/* Honeypot */}
          <input
            type="text"
            name="_honey"
            className="jb-honey"
            tabIndex={-1}
            autoComplete="off"
          />

          <div className="jb-row">
            <input
              className="jb-input"
              type="text"
              name="name"
              placeholder="Your name"
              required
            />
            <input
              className="jb-input"
              type="email"
              name="email"
              placeholder="Your email"
              required
            />
          </div>

          <input className="jb-input" type="text" name="subject" placeholder="Subject" />

          <textarea
            className="jb-textarea"
            name="message"
            placeholder="Your message"
            required
          />

          <div className="jb-actions">
            <button className="jb-btn" type="submit">
              Send Message
            </button>
          </div>

          <div className="jb-note">
            This form emails <strong>admin@junebase.com</strong>.
          </div>
        </form>
      </div>
    </section>
  );
}